import React from "react";
import { ChevronDown } from "lucide-react";
import NoFluxo from "./NoFluxo";
import { SEQUENCIA } from "../../data/fluxosAutomacao";

/**
 * FluxoVertical — a mesma operação empilhada, para telas estreitas.
 *
 * Não é o palco comprimido: a trilha horizontal não sobrevive a 360px. Aqui as
 * etapas viram uma coluna com conectores, e o ramo da decisão aparece recuado
 * logo abaixo dela, marcado como "não".
 *
 * Os cards mantêm o mini-conteúdo (é ele que conta a história), e o mesmo
 * `passo` da seção destaca a etapa em execução.
 */

// Na vertical o ramo "não" vem logo depois da decisão, onde a leitura espera.
const ORDEM_VERTICAL = ["cliente", "ia", "sistema", "decisao", "alternativa", "acao", "humano", "sucesso"];

function Conector({ rotulo }) {
  return (
    <div className="flex items-center justify-center gap-1.5 py-1.5" aria-hidden="true">
      <span
        className="block w-px"
        style={{ height: 18, background: "linear-gradient(180deg, rgba(34,197,94,0.5), rgba(34,197,94,0.12))" }}
      />
      {rotulo && (
        <span className="text-[10px] font-bold uppercase tracking-wider text-amber-400/90">
          {rotulo}
        </span>
      )}
      <ChevronDown className="h-3 w-3 text-green-500/50" />
    </div>
  );
}

export default function FluxoVertical({ fluxo, passo = 0 }) {
  const porId = Object.fromEntries(fluxo.etapas.map((e) => [e.id, e]));
  const etapas = ORDEM_VERTICAL.map((id) => porId[id]).filter(Boolean);
  const idAtivo = SEQUENCIA[passo];

  return (
    // Largura travada: em tablet um card esticado em 1000px deixaria o
    // mini-conteúdo perdido no meio do vazio.
    <div className="mx-auto flex w-full max-w-[460px] flex-col" data-testid="fluxo-vertical">
      {etapas.map((etapa, i) => {
        const ramo = !SEQUENCIA.includes(etapa.id);
        return (
          <React.Fragment key={etapa.id}>
            {i > 0 && <Conector rotulo={ramo ? "não" : null} />}
            <div className={ramo ? "pl-5" : ""}>
              <NoFluxo
                etapa={etapa}
                ordem={i}
                ativo={etapa.id === idAtivo}
                atenuado={ramo && idAtivo !== "decisao"}
              />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
